import React, { useCallback, useMemo } from 'react';
import { useRefCallback } from '@bydesign-ui/hooks';
import { guid } from '@bydesign-ui/utils';
import { useConfig, usePrefixCls } from '@byte-design/config';
import { Down, Up } from '../../../common/icons';
import { TreeMapState, useCascader } from '../../../hooks/cascader';
import { RcClickTrigger } from '../../../hooks/popper';
import { RcPopover } from '../../../units/popover-wrapper';
import { SelectInputWrapper } from '../../util/SelectInputWrapper';
import { useCascaderSelectPopper } from '../hooks/useCascaderSelectPopover';
export function CascaderSelectMultiplePopper(props) {
  var renderItem = props.renderItem,
      _props$placement = props.placement,
      placement = _props$placement === void 0 ? 'bottom-start' : _props$placement,
      autoAlign = props.autoAlign,
      maxPopoverWidth = props.maxPopoverWidth,
      placeholder = props.placeholder,
      onVisibleChange = props.onVisibleChange,
      onSearchChange = props.onSearchChange,
      onShow = props.onShow,
      onHide = props.onHide,
      show = props.show,
      _props$size = props.size,
      size = _props$size === void 0 ? 'md' : _props$size,
      disabled = props.disabled,
      renderSelectedName = props.renderSelectedName,
      _props$clearable = props.clearable,
      clearable = _props$clearable === void 0 ? false : _props$clearable,
      renderSearchItem = props.renderSearchItem,
      searchPlaceholder = props.searchPlaceholder,
      _props$searchable = props.searchable,
      searchable = _props$searchable === void 0 ? false : _props$searchable,
      emptyRender = props.emptyRender,
      emptyContent = props.emptyContent,
      invalid = props.invalid,
      filled = props.filled;
  var cascader = useCascader();
  var triggerId = useMemo(function () {
    return guid();
  }, []);
  var triggerIds = useMemo(function () {
    return [triggerId];
  }, []);
  var refPopoverId = useMemo(function () {
    return guid();
  }, []);

  var _useConfig = useConfig(),
      componentSizeMap = _useConfig.componentSizeMap;

  var inputPopoverCls = usePrefixCls('cascader-input-popover');
  var placeholderInputCls = usePrefixCls('cascader-select-input-placeholder');
  var triggerCls = usePrefixCls('cascader-multiple-input-trigger');

  var _useCascaderSelectPop = useCascaderSelectPopper({
    show: show,
    autoAlign: autoAlign,
    triggerId: triggerId,
    renderItem: renderItem,
    maxPopoverWidth: maxPopoverWidth,
    searchable: searchable,
    searchPlaceholder: searchPlaceholder,
    renderSearchItem: renderSearchItem,
    onSearchChange: onSearchChange,
    emptyRender: emptyRender,
    emptyContent: emptyContent
  }),
      displayInfo = _useCascaderSelectPop.displayInfo,
      getPopover = _useCascaderSelectPop.getPopover;

  var handleDelete = useCallback(function (item) {
    cascader.setItemState(item.value, TreeMapState.UNSELECTED);
  }, []);
  var handleShow = useRefCallback(onShow);
  var handleHide = useRefCallback(onHide);
  var handleClear = useCallback(function () {
    cascader.resetValue();
  }, []);
  return React.createElement(React.Fragment, null, React.createElement(RcClickTrigger, {
    triggerId: triggerId,
    disabled: disabled,
    className: triggerCls
  }, React.createElement(SelectInputWrapper, {
    show: show,
    icon: show ? React.createElement(Up, null) : React.createElement(Down, null),
    multiple: cascader.multiple,
    datasource: displayInfo,
    popperInput: show,
    onCloseItem: handleDelete,
    className: placeholderInputCls,
    placeholder: placeholder,
    size: size,
    disabled: disabled,
    renderSelectedName: renderSelectedName,
    clearable: clearable,
    onClear: handleClear,
    invalid: invalid,
    filled: filled
  })), React.createElement(RcPopover, {
    show: show,
    getPopper: function getPopper() {
      return React.createElement("div", {
        style: {
          height: componentSizeMap[size].height
        }
      });
    },
    arrow: false,
    placement: placement,
    offset: {
      x: 0,
      y: -componentSizeMap[size].height
    },
    onVisibleChange: onVisibleChange,
    onShow: handleShow,
    onHide: handleHide,
    triggerIds: triggerIds,
    popoverId: refPopoverId,
    refType: "trigger",
    refId: triggerId,
    preventOverflow: false,
    className: inputPopoverCls,
    scaleAnimation: false
  }), React.createElement(RcPopover, {
    show: show,
    getPopper: getPopover,
    arrow: false,
    offset: {
      x: 0,
      y: 4
    },
    placement: placement,
    triggerIds: triggerIds,
    refType: "popover",
    refId: refPopoverId,
    unionPopoverIds: [refPopoverId],
    scaleAnimation: "y"
  }));
}